import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { sha256 } from '@noble/hashes/sha256';
import { sha512 } from '@noble/hashes/sha512';
import { getCryptoLib } from './cryptoUtils';
export var NodeCryptoSha2Hash =
/*#__PURE__*/
function () {
  function NodeCryptoSha2Hash(createHash) {
    _classCallCheck(this, NodeCryptoSha2Hash);

    this.createHash = createHash;
  }

  _createClass(NodeCryptoSha2Hash, [{
    key: "digest",
    value: function () {
      var _digest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data) {
        var algorithm,
            result,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                algorithm = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'sha256';
                _context.prev = 1;
                result = this.createHash(algorithm).update(data).digest();
                return _context.abrupt("return", Promise.resolve(result));

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
                console.log("Error performing ".concat(algorithm, " digest with Node.js 'crypto.createHash', falling back to JS implementation."));
                return _context.abrupt("return", Promise.resolve(algorithm === 'sha256' ? hashSha256Sync(data) : hashSha512Sync(data)));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function digest(_x) {
        return _digest.apply(this, arguments);
      }

      return digest;
    }()
  }]);

  return NodeCryptoSha2Hash;
}();
export var WebCryptoSha2Hash =
/*#__PURE__*/
function () {
  function WebCryptoSha2Hash(subtleCrypto) {
    _classCallCheck(this, WebCryptoSha2Hash);

    this.subtleCrypto = subtleCrypto;
  }

  _createClass(WebCryptoSha2Hash, [{
    key: "digest",
    value: function () {
      var _digest2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(data) {
        var algorithm,
            algo,
            hash,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                algorithm = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'sha256';

                if (!(algorithm === 'sha256')) {
                  _context2.next = 5;
                  break;
                }

                algo = 'SHA-256';
                _context2.next = 10;
                break;

              case 5:
                if (!(algorithm === 'sha512')) {
                  _context2.next = 9;
                  break;
                }

                algo = 'SHA-512';
                _context2.next = 10;
                break;

              case 9:
                throw new Error("Unsupported hash algorithm ".concat(algorithm));

              case 10:
                _context2.prev = 10;
                _context2.next = 13;
                return this.subtleCrypto.digest(algo, data);

              case 13:
                hash = _context2.sent;
                return _context2.abrupt("return", new Uint8Array(hash));

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](10);
                console.log(_context2.t0);
                console.log("Error performing ".concat(algorithm, " digest with WebCrypto, falling back to JS implementation."));
                return _context2.abrupt("return", Promise.resolve(algorithm === 'sha256' ? hashSha256Sync(data) : hashSha512Sync(data)));

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 17]]);
      }));

      function digest(_x2) {
        return _digest2.apply(this, arguments);
      }

      return digest;
    }()
  }]);

  return WebCryptoSha2Hash;
}();
export function createSha2Hash() {
  return _createSha2Hash.apply(this, arguments);
}

function _createSha2Hash() {
  _createSha2Hash = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var cryptoLib;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getCryptoLib();

          case 2:
            cryptoLib = _context3.sent;

            if (!(cryptoLib.name === 'subtleCrypto')) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", new WebCryptoSha2Hash(cryptoLib.lib));

          case 7:
            return _context3.abrupt("return", new NodeCryptoSha2Hash(cryptoLib.lib.createHash));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _createSha2Hash.apply(this, arguments);
}

export function hashSha256Sync(data) {
  return sha256(data);
}
export function hashSha512Sync(data) {
  return sha512(data);
}